import React from 'react'
import { ButtonReg } from 'atoms/Buttons'
import { Label } from 'atoms/Texts'
import IconPng from 'atoms/IconPng'
import { StyledContainer, LabelPadded, IconWrapper } from './styles'
import { withTheme } from 'styled-components';

const LabelIcon = ({ icon, text, showPointer, ...rest }) => {
  return (
    <StyledContainer showPointer={showPointer} {...rest}>
      <IconWrapper>
        <IconPng srcIcon={icon} ml={'0'} size={'auto'} h={'20'} showPointer={showPointer} />
      </IconWrapper>
      <Label mb={'0'} weight={'500'} showPointer={showPointer}>{text}</Label>
    </StyledContainer>
  )
}

const LabelBtn = ({ theme, text, value, transparent, ...rest }) => {
  let btnColor
  let val

  switch (value) {
    case false:
      btnColor = theme.mocaRed
      break;
    case 'HIGH':
      btnColor = theme.mocaRed
      break;
    case 'MEDIUM':
      btnColor = theme.mocaOrange
      break;

    default:
      btnColor = theme.mocaGreen
      break;
  }

  switch (value) {
    case true:
      val = 'CLOSED'
      break;
    case false:
      val = 'OPEN'
      break;
    default:
      val = value
      break;
  }

  return (
    <StyledContainer>
      <LabelPadded mb={'0'} weight={'500'} {...rest}>{text}:</LabelPadded>
      <ButtonReg
        width={`68px`}
        height={'27px'}
        size={'12px'}
        bg={btnColor}
        color={transparent ? btnColor : theme.white}
        transparent={transparent}
        bordered={transparent}
        btnTxt={val}
        noclick={true}
      />
    </StyledContainer>
  )
}

const LabelWithIcon = withTheme(LabelIcon)
const LabelWithStatus = withTheme(LabelBtn)
export {
  LabelWithIcon,
  LabelWithStatus
}
